import { Badge, Icon } from 'components';
import { isMobile } from 'core';
import styled from 'styled-components';

const Wrapper = styled.div`
  cursor: pointer;
  padding: ${(props) => (props.isMobile ? '10px' : '15px')};
  border-radius: 100%;
  background-color: grey;
  right: 20px;
  position: absolute;
`;

const RelativeContainer = styled.div`
  position: relative;
`;

const BadgeContainer = styled.div`
  position: absolute;
  right: -20px;
  top: -20px;
`;

const ChatButton = ({ unreadCount, chatVisible, handleChatVisible }) => {
  return (
    <Wrapper bg="grey" onClick={handleChatVisible} isMobile={isMobile}>
      <RelativeContainer>
        {!!unreadCount && (
          <BadgeContainer>
            <Badge>{unreadCount}</Badge>
          </BadgeContainer>
        )}

        <Icon type="message" dimensions={isMobile ? 15 : 25} />
      </RelativeContainer>
    </Wrapper>
  );
};

export default ChatButton;
